import { render, staticRenderFns } from "./ExEmployeeWizardModal.vue?vue&type=template&id=64e126e6&scoped=true"
import script from "./ExEmployeeWizardModal.vue?vue&type=script&lang=js"
export * from "./ExEmployeeWizardModal.vue?vue&type=script&lang=js"
import style0 from "./ExEmployeeWizardModal.vue?vue&type=style&index=0&id=64e126e6&prod&scoped=true&lang=css"
import style1 from "./ExEmployeeWizardModal.vue?vue&type=style&index=1&id=64e126e6&prod&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64e126e6",
  null
  
)

export default component.exports